// extracted by mini-css-extract-plugin
module.exports = {"mCard":"ob","image":"pb","imageNoBackground":"qb"};